module.exports = "//static.hsappstatic.net/ui-addon-upgrades/static-9.7135/js/img/OperationsHub_Icon.svg"